import styled from 'styled-components';
import materialUI from '../../material-UI';

export const Column: any = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Row: any = styled.div`
  display: flex;
  flex-direction: Row;
`;
export const RowLeft: any = styled.div`
  display: flex;
  flex-direction: Row;
  width: 40%;
  margin: 0px 30px 0px 30px;
`;
export const RowRight: any = styled.div`
  display: flex;
  flex-direction: Row;
  width: 60%;
  margin: 0px 30px 0px 30px;
`;
export const Space: any = styled.div`
  width: 32px;
`;
export const TitleType = styled.div`
  font-size: 14px;
  font-family: Inter;
  margin: 0px 0px 0px 32px;
`;
export const Img: any = styled.img``;
export const Margin: any = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
`;
export const OnPress = styled(materialUI.IconButton)`
  height: 32px;
  width: 32px;
`;
export const Divider = styled(materialUI.Divider)`
  margin-top: 8px;
  margin-left: 32px;
  margin-right: 32px;
  margin-bottom: 26px;
`;
export const SizedBox: any = styled.div`
  height: 32px;
`;
export const Card = styled(materialUI.Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 184px;
  margin-top: 32px;
  margin-right: 12px;
  margin-left: 12px;
  padding-bottom: 15px;
  cursor: pointer;
`;
export const ImgCheck: any = styled.img``;
export const ImgPlace: any = styled.img`
  width: 100%;
  padding: 10px;
  height: 120px;
`;
export const ImgCriterion: any = styled.img`
  width: 80px;
  padding: 10px;
  height: auto;
`;
export const Title: any = styled.div`
  font-family: Inter;
  font-size: 12px;
`;
export const ContainerList: any = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex-grow: 1;
  margin: 0px 20px 0px 30px;
`;
